import React from "react";
import Navbar from "../Components/Navigation/Navbar";
import Footer from "../Components/Navigation/footer";
import MetaResetHandler from "../utils/meta-reset-handler";

function MainLayout({ children }: { children: any }) {
  return (
    <div>
      <MetaResetHandler />
      <Navbar />
      {children}
      <Footer />
    </div>
  );
}

export default MainLayout;
